import styled from 'styled-components';

export const StyledFabelTownSection = styled.div<{ textColor: string }>`
  font-family: var(--font-family), Arial;
  width: 200px;
  min-height: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: linear-gradient(180deg, #D771BE 0%, #C151E1 100%);
  box-shadow: 0px 0px 9.564px 0px rgba(0, 0, 0, 0.25),
    0px -1.392px 2.784px 0px rgba(0, 0, 0, 0.25) inset,
    0px 1.392px 1.392px 0px #EC92CB inset,
    0px -2.784px 1.392px 0px #8210BE inset;
  border-radius: 20px;

  .section-fabeltown__content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section-fabeltown__section-name {
    width: 100%;
    max-width: 180px;
    color: #fff;
    font-weight: 800;
    text-shadow: 
      -0.5px -0.5px 0 #6F0EA2,
      0.5px -0.5px 0 #6F0EA2,
      -0.5px  0.5px 0 #6F0EA2,
      0.5px  0.5px 0 #6F0EA2;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    display: block;
    text-align: center;
  }
`;
